var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZippayPaymentImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7902 0H4.20978C1.88478 0 0 1.88478 0 4.20978V25.7902C0 28.1152 1.88478 30 4.20978 30H25.7902C28.1152 30 30 28.1152 30 25.7902V4.20978C30 1.88478 28.1152 0 25.7902 0Z",
    fill: "#AA8FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9674 6.79431H4.09776L4.80448 11.9674H14.0326V12.6741L5.54786 18.664L6.14461 23.2037H25.9022L25.3055 17.9572H16.0794L15.9308 17.2139L24.5255 11.2607L23.9674 6.79431Z",
    fill: "#190827"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZippayPaymentImage);
export default __webpack_public_path__ + "static/media/zippay-payment-image.7ce470c89e18295396c0a38d1b23ac4c.svg";
export { ForwardRef as ReactComponent };